import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Mode } from 'app/modules/main/components/table-controls/table-controls.models';
import { Option } from 'app/modules/main/components/table-controls/table-controls.models';
import { Menu } from 'app/modules/main/components/table-controls/table-controls.models';
import { TableView } from 'app/modules/main/components/table-controls/table-controls.models';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-table-controls',
  templateUrl: './table-controls.component.html',
  styleUrls: ['./table-controls.component.css'],
})
export class TableControlsComponent {

  @Input() readonly disabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() readonly tableViews: BehaviorSubject<TableView[]>;

  private readonly menuOptions = new Map<Menu, Option>();

  activateTableView(
    tableView: TableView
  ): void {

    if (this.disabled.value) {
      return;
    }

    if (tableView.active) {
      return;
    }

    const activeView =
      this.tableViews.value.find(_view => _view.active);

    if (activeView) {
      activeView.active = false;
      activeView.change.next(true);
    }

    tableView.active = true;
    tableView.activate && tableView.activate(tableView);

    tableView.change.next(true);
  }

  activateMode(
    tableView: TableView,
    mode: Mode
  ): void {

    if (this.disabled.value) {
      return;
    }

    if (mode.active) {
      return;
    }

    const activeMode =
      tableView.modes.find(_mode => _mode.active);

    if (activeMode) {
      activeMode.active = false;
    }

    mode.active = true;
    mode.activate && mode.activate(tableView, mode);

    tableView.change.next(true);
  }

  selectOption(
    tableView: TableView,
    menu: Menu,
    option: Option
  ): void {

    if (this.disabled.value) {
      return;
    }

    if (option.selected) {
      return;
    }

    const selectedOption =
      menu.options.find(_option => _option.selected);

    if (selectedOption) {
      selectedOption.selected = false;
    }

    option.selected = true;
    option.select && option.select(tableView, menu, option);

    menu.select && menu.select(tableView, menu, option);

    tableView.change.next(true);
  }

  getOrCreateModel(
    menu: Menu
  ) {
    const selectedOption =
      menu.options.find(option => option.selected);

    this.menuOptions.set(menu, selectedOption);

    return this.menuOptions.get(menu);
  }

}
